import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholipuneplacetoexplorenearby() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Pune Place to Explore Nearby',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Pune Place to Explore Nearby',
        headingDescription: 'Looking for a peaceful and refreshing place to explore nearby Morachi Chincholi Pune? Anand Krushi Paryatan Kendra offers the ideal one-day rural escape just 55 km from Pune. Spread across 40 acres of lush farmland, this eco-friendly agri-tourism center perfectly blends natural beauty, traditional village life, and engaging activities. Recognized as a top Morachi Chincholi Pune place to explore nearby, the center provides a variety of rural experiences including bullock cart and tractor rides, horse riding, boating, swimming, rain dance, and exciting village games. Cultural performances like puppet shows and magic shows add to the charm.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi Peacock Village",
    "description": "A unique agro-tourism village known for its population of over 2,000 free-roaming peacocks. Watch them dance and glide in open fields — a rare, serene experience just 55 km from Pune."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "A 40-acre agri-tourism center offering tractor rides, bullock cart safaris, organic farming demos, village-style meals, rural games, pottery, and splash zones — ideal for families and school groups."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "One of the revered Ashtavinayak temples, located about 25 km away. Visit for its beautiful architecture, spiritual ambiance, and quick darshan route from Morachi Chincholi."
  },
  {
    "title": "Ghod River Backwaters",
    "description": "A peaceful riverside location just a few km away, perfect for a relaxing picnic, birdwatching, or scenic photography amidst nature."
  },
  {
    "title": "Tulapur Historical Site",
    "description": "A significant Maratha history spot where Chhatrapati Sambhaji Maharaj was martyred. Located on the banks of the Bhima River, it’s a great place to explore history and culture."
  },
  {
    "title": "Shivneri Fort",
    "description": "The birthplace of Chhatrapati Shivaji Maharaj, around 60 km away. Offers trekking routes, stunning views, and deep historical insight into the Maratha Empire."
  },
  {
    "title": "Bhuleshwar Temple",
    "description": "An ancient Shiva temple around 50 km from Morachi Chincholi. Known for its intricate carvings and Indo-Islamic style, it’s a perfect blend of history and spirituality."
  },
  {
    "title": "Chintamani Ganpati Temple, Theur",
    "description": "Another Ashtavinayak Ganpati temple located about 65 km away. Can be included in a spiritual circuit with Ranjangaon and Morachi Chincholi."
  },
  {
    "title": "Hurda Party (Seasonal Activity)",
    "description": "Enjoy roasted green jowar (hurda) along with chutneys and jaggery, a winter specialty (Nov–Feb) organized at many local farms with folk music and rural games."
  }
],




"services": [
  {
    "name": "Exploration Spots Around Morachi Chincholi",
    "description": "Looking for exciting places to explore near Morachi Chincholi? Anand Krushi Paryatan Kendra is your ideal base for rural discovery, combining natural beauty, cultural richness, and hands-on experiences for all age groups."
  },
  {
    "name": "Nature Reserves and Parks",
    "description": "Surround yourself with greenery and tranquility at Anand Krushi Paryatan Kendra’s own nature zones. Nearby, explore groves, orchards, and natural parks that offer peaceful escapes perfect for nature enthusiasts and photographers alike."
  },
  {
    "name": "Heritage and Historical Sites",
    "description": "Venture out to ancient forts, temples, and rural landmarks near Morachi Chincholi. At Anand Krushi Paryatan Kendra, you’ll find cultural displays and activities that honor the agricultural and historical legacy of Maharashtra."
  },
  {
    "name": "Cultural Villages",
    "description": "Experience the charm of traditional Maharashtrian village life. Anand Krushi Paryatan Kendra recreates a vibrant village environment through folk music, rural games, and immersive farming experiences."
  },
  {
    "name": "Wildlife Sanctuaries Nearby",
    "description": "Discover nearby forested areas and sanctuaries teeming with flora and fauna. Known for its peacock sightings, the farm also provides a safe space for observing other native species in their natural habitat."
  },
  {
    "name": "Local Artisan Villages",
    "description": "Explore villages near Morachi Chincholi that are home to skilled artisans. Many of their handmade items, such as pottery, woven baskets, and traditional snacks, are also featured in the farm's on-site local market."
  },
  {
    "name": "Scenic Hiking Trails",
    "description": "Lace up your boots and enjoy light nature hikes around Anand Krushi Paryatan Kendra. Whether you’re walking through orchards or scenic rural paths, the terrain offers peaceful exploration perfect for slow travel seekers."
  },
  {
    "name": "Adventure Zones",
    "description": "Add some action to your day with adventure activities at the farm, including rope courses, tire bridges, climbing walls, and rural obstacle zones. Great for families, school trips, and team-building groups."
  },
  {
    "name": "Bird Sanctuaries",
    "description": "As part of the Morachi Chincholi peacock belt, the farm provides close encounters with beautiful birds in their natural environment. Enjoy quiet morning birdwatching or guided walks to spot species around the farm’s periphery."
  },
  {
    "name": "Family Outing Places",
    "description": "Anand Krushi Paryatan Kendra is tailor-made for family fun, with open spaces, kids’ play areas, animal interaction zones, and traditional rural games that both kids and adults can enjoy together."
  },
  {
    "name": "Picnic and Leisure Spots",
    "description": "Settle down under a tree or by the gazebo for a relaxing picnic at the farm. With delicious homemade meals available, it’s the perfect spot to unwind, chat, and enjoy rural hospitality close to nature."
  },
  {
    "name": "Eco-Tourism Locations",
    "description": "Promoting sustainability and responsible tourism, Anand Krushi Paryatan Kendra is a model eco-tourism destination with organic practices, natural construction, and water conservation efforts that educate while they entertain."
  },
  {
    "name": "Photography Spots",
    "description": "Capture postcard-worthy shots of lush fields, rustic architecture, peacocks, and cultural moments. Whether you’re into landscape, wildlife, or portrait photography, the farm offers countless picturesque angles."
  },
  {
    "name": "Water Bodies and Lakes",
    "description": "Visit serene ponds and small water bodies within or near the farm that attract birds and offer relaxing views. Perfect for reflection, leisure, or simply cooling off after a walk."
  },
  {
    "name": "Rural Tourism Experiences",
    "description": "Step into the shoes of a farmer with hands-on experiences like planting, harvesting, and composting. Anand Krushi Paryatan Kendra offers a genuine rural tourism experience that is both fun and educational."
  }
],
"tableData": [
  ["Exploration Spots Around Morachi Chincholi", "- Nature Reserves and Parks"],
  ["Heritage and Historical Sites", "- Cultural Villages"],
  ["Wildlife Sanctuaries Nearby", "- Local Artisan Villages"],
  ["Scenic Hiking Trails", "- Adventure Zones"],
  ["Bird Sanctuaries", "- Family Outing Places"],
  ["Picnic and Leisure Spots", "- Eco-Tourism Locations"],
  ["Photography Spots", "- Water Bodies and Lakes"],
  ["Rural Tourism Experiences", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Nighoj Potholes (Kukadi River Gorge)",
    "WhyChoosedescription": "About 25 km from Morachi Chincholi, Nighoj is known for its rare geological formations—potholes carved by the Kukadi River. It's a must-visit for nature enthusiasts and geology lovers."
  },
  {
    "WhyChooseheading": "Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "This sacred Ashtavinayak temple, dedicated to Lord Ganesha, is located around 40–45 km away. Known for its divine aura and grand architecture, it's a peaceful and spiritually enriching visit."
  },
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "Situated about 20 km from Morachi Chincholi, Shirur Fort offers panoramic views and a slice of local history. Ideal for a short exploration or a quiet sunset visit."
  },
  {
    "WhyChooseheading": "Bhuleshwar Temple",
    "WhyChoosedescription": "Roughly 50 km from Morachi Chincholi, this 13th-century hilltop temple dedicated to Lord Shiva is famous for its carvings and serene ambiance—perfect for architecture lovers and spiritual seekers."
  },
  {
    "WhyChooseheading": "Vadgaon Dam",
    "WhyChoosedescription": "Located near Shirur, Vadgaon Dam is a peaceful nature spot with calm waters and surrounding greenery. It's great for picnics, casual walks, and family relaxation."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra",
    "WhyChoosedescription": "Right within Morachi Chincholi, this agro-tourism destination offers farm tours, peacock watching, traditional Maharashtrian meals, adventure activities, and cultural programs for a wholesome rural experience."
  },
  {
    "WhyChooseheading": "Ramling Mandir",
    "WhyChoosedescription": "About 30 km away, this Lord Shiva temple is nestled in nature and provides a calm and spiritual retreat. A simple yet fulfilling stop for quiet moments."
  },
  {
    "WhyChooseheading": "Ganesh Khind Picnic Spot",
    "WhyChoosedescription": "A lesser-known gem near Shirur, Ganesh Khind is a serene outdoor spot surrounded by trees and rural landscapes—perfect for peaceful nature exploration and picnicking."
  }
]













    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'What are the best places to explore near Morachi Chincholi?',
    answer: 'Nearby places include Ranjangaon Mahaganpati Temple, Alandi (Sant Dnyaneshwar Samadhi), Anand Krushi Paryatan Kendra, Shikrapur, and the Jejuri Khandoba Temple.',
  },
  {
    id: 'FAQ2',
    question: 'Is Ranjangaon Ganpati Temple close to Morachi Chincholi?',
    answer: 'Yes, it’s about 25–30 km away. It’s one of the eight Ashtavinayak Ganpati temples and can be visited in the same trip.',
  },
  {
    id: 'FAQ3',
    question: 'What can I do at Anand Krushi Paryatan Kendra?',
    answer: 'You can enjoy bullock cart rides, tractor rides, butterfly watching, nature walks, rural games, and traditional Maharashtrian meals.',
  },
  {
    id: 'FAQ4',
    question: 'Is Alandi a good stop for spiritual tourism?',
    answer: 'Yes. Alandi is a revered site with the Samadhi of Saint Dnyaneshwar and is about 35 km from Morachi Chincholi.',
  },
  {
    id: 'FAQ5',
    question: 'Are there nature or wildlife experiences nearby?',
    answer: 'Yes. Morachi Chincholi itself is a peacock sanctuary with hundreds of free-roaming peacocks, making it perfect for birdwatchers and nature photographers.',
  },
  {
    id: 'FAQ6',
    question: 'Can these places be covered in a one-day trip?',
    answer: 'Yes. You can plan a loop from Pune to Morachi Chincholi, Anand Krushi, Ranjangaon Temple, and back in one well-planned day.',
  },
  {
    id: 'FAQ7',
    question: 'Are there places to eat near these spots?',
    answer: 'Agro-tourism centers like Anand Krushi offer fresh, home-cooked meals. Temples and villages nearby also have small eateries and food stalls.',
  },
  {
    id: 'FAQ8',
    question: 'Is this area suitable for photography?',
    answer: 'Absolutely! Between the vibrant peacocks, farms, temples, and village life, there are plenty of scenic photo opportunities.',
  },
  {
    id: 'FAQ9',
    question: 'Is the area accessible by private or public transport?',
    answer: 'Private vehicles or hired taxis are most convenient. Public transport is limited, but buses go up to nearby towns like Shikrapur and Alandi.',
  },
  {
    id: 'FAQ10',
    question: 'What’s the best time to explore this region?',
    answer: 'Visit between June and November for lush greenery, cool weather, and the highest chance to spot peacocks in the wild.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Swapnil Kendre, Pune',
    feedback: "We explored Morachi Chincholi, Anand Krushi, and Ranjangaon on a weekend. It was peaceful and refreshing—peacocks, farms, and temples all in one day!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meenal Joshi, Nashik',
    feedback: "Alandi and Morachi Chincholi gave us the perfect mix of spiritual peace and natural beauty. Highly recommended for a short road trip from Pune.",
    rating: 5,
  },
];














    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Pune Place to Explore Nearby",
  "image": "https://morachichincholi.in/assets/images/place-to-explore-nearby-morachi-chincholi.jpg",
  "description": "Explore nearby places around Morachi Chincholi Pune — from scenic hiking trails, lakes, bird sanctuaries, and eco-tourism locations to heritage sites, cultural villages, and rural tourism experiences at Anand Krushi Paryatan Kendra.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2146"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "580",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/place-to-explore-nearby"
  }
};



    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Pune Place to Explore Nearby | Nature Trails, Lakes & Heritage | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Find exciting places to explore near Morachi Chincholi Pune including scenic trails, bird sanctuaries, cultural villages, picnic spots, and rural tourism experiences hosted by Anand Krushi Paryatan Kendra." 
  />
  <meta 
    name="keywords" 
    content="Exploration spots around Morachi Chincholi, Nature reserves and parks, Heritage and historical sites, Cultural villages, Wildlife sanctuaries nearby, Local artisan villages, Scenic hiking trails, Adventure zones, Bird sanctuaries, Family outing places, Picnic and leisure spots, Eco-tourism locations, Photography spots, Water bodies and lakes, Rural tourism experiences" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholipuneplacetoexplorenearby;